import apiService from '../../../services/api'

/**
 * Double API Service
 * Работа с эндпоинтами /api/double/*
 */
export const doubleApi = {
  // Получить текущий активный раунд
  getActiveRound: async (signal) => {
    const response = await apiService.makeRequest('/api/double/', {
      method: 'GET',
      signal
    })
    return response
  },

  // Получить раунд по ID
  getRoundById: async (roundId) => {
    const response = await apiService.makeRequest(`/api/double/${roundId}/`, {
      method: 'GET'
    })

    if (response?.error) {
      const error = new Error(response.error)
      error.message = response.error
      throw error
    }

    return response
  },

  // История всех раундов
  getHistoryAll: async () => {
    const response = await apiService.makeRequest('/api/double/history/', {
      method: 'GET'
    })
    return response
  },

  // История раундов текущего пользователя
  getHistoryMine: async () => {
    const response = await apiService.makeRequest('/api/double/history/me/', {
      method: 'GET'
    })
    return response
  },

  // Быстрая история: последние 10 раундов + последние 50 ставок пользователя
  getHistoryFast: async () => {
    const response = await apiService.makeRequest('/api/double/history/fast/', {
      method: 'GET'
    })
    return response
  },

  // Данные для формы ставки (инвентарь + баланс)
  getBetForm: async (signal) => {
    const response = await apiService.makeRequest('/api/double/bet/', {
      method: 'GET',
      signal
    })
    return response
  },

  // Сделать ставку
  placeBet: async ({ roundId, color, crystal, items }) => {
    const payload = {
      round_id: roundId,
      color
    }

    if (Number(crystal || 0) > 0) {
      payload.crystal = Number(crystal)
    }

    if (Array.isArray(items) && items.length > 0) {
      payload.items = items
    }

    const response = await apiService.makeRequest('/api/double/bet/', {
      method: 'POST',
      body: JSON.stringify(payload)
    })

    if (response?.error) {
      const error = new Error(response.error)
      error.message = response.error
      throw error
    }

    return response
  }
}

export default doubleApi
